import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';
// import services from './services';

const uploader = {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
  // services,
};

export default uploader;
